import React from 'react';

import { AdCampaignTypeEnum } from '@entities/media';

import Popper, { HintPlacement } from '@zvuk-b2b/react-uikit/ui/Popper';
import IconHelpCircle from '@zvuk-b2b/react-uikit/ui/icons/HelpCircle';

import DisabledInstantAdHint from '../DisabledInstantAdHint';

import styles from './index.module.scss';

export type AdTypeSelectOptionContentProps = {
  value: AdCampaignTypeEnum;
  type: string;
  isDisabled: boolean;
  isLinkDisabled?: boolean;
  title: string;
  onClick: () => void;
};

const AdTypeSelectOptionContent = ({
  value,
  type,
  isDisabled,
  isLinkDisabled = false,
  title,
  onClick,
}: AdTypeSelectOptionContentProps) => {
  const content = (
    <span
      className={styles.AdTypeSelectOptionContent}
      data-selected={value === type}
      data-disabled={isDisabled}>
      {title}
      {isDisabled && (
        <span
          id="ad_instant_content_hint"
          className={styles.AdTypeSelectOptionContentIcon}>
          <IconHelpCircle />
        </span>
      )}
    </span>
  );

  if (!isDisabled) {
    return content;
  }

  return (
    <Popper
      containerClassName={styles.AdTypeSelectOptionContentPopperContainer}
      triggerNode={content}
      isShow
      isShowingOnClick
      placement={HintPlacement.PLACEMENT_TOP_END}
      portalNode={document.body}
      popperClassName={styles.AdTypeSelectOptionContentPopper}>
      <DisabledInstantAdHint
        isLinkDisabled={isLinkDisabled}
        onClick={onClick}
      />
    </Popper>
  );
};

export default AdTypeSelectOptionContent;
